import { Enum } from "./Enum";

export const E_CATEGORIES = Object.freeze({
  MAIN: "/category",
  CATEGORY_ID: (id: string = ":id") => `/category/${id}`,
});

export type E_CATEGORIES = Enum<typeof E_CATEGORIES>;
